import React from 'react';

const UserDonations = () => {
  return <div>Donations</div>;
};

export default UserDonations;
